import { z } from 'zod';
import { COST_CENTER_SPLIT_FEATURE_FLAGS } from '../cost_center_split/cost_center_split.js';
import { GROUP_EVENTS_FEATURE_FLAGS } from '../group_events/group_events_entry.js';
import {
  CLASSIC_EXIT_BLOCK_FEATURE_FLAGS,
  INTELLIGENCE_CHAT_FEATURE_FLAGS,
} from './intelligence_access.js';
import { KM_GPS_FEATURE_FLAGS } from '../km_refund/km_tracked_entry.js';
import { MOBILITY_99_FEATURE_FLAGS } from '../mobility/mobility99_entry.js';
import { MOBILITY_99_BATCH_FEATURE_FLAGS } from '../mobility/ride_batch_entry.js';
import { MOBILITY_SCHEDULING_FEATURE_FLAGS } from '../mobility/mobility_scheduling_entry.js';
import { VOLL_WALLET_FEATURE_FLAGS } from '../voll_wallet/voll_wallet_entry.js';
import { VOLL_WALLET_USER_CARD_FEATURE_FLAGS } from '../voll_wallet/voll_wallet_user_card.js';

/** Toda flag do feature-flag-service (`currentFeatures(system: USER_APP)`) que algum serviço
 *  daqui consome. O customer-api filtra a resposta do legado por esta lista: nada fora dela sai
 *  de lá. Flag nova consumida aqui = entra nesta lista. */
export const LEGACY_FEATURE_FLAGS = [
  // shortcut: o app-integration antigo ainda exige esta flag para a corrida com a 99 e o
  // deploy-prod sobe o customer-api em paralelo; remover depois que o app-integration sem a flag
  // (#7330) estiver em prod.
  'mobility_99',
  ...MOBILITY_99_FEATURE_FLAGS,
  ...VOLL_WALLET_FEATURE_FLAGS,
  // shortcut: o app-integration antigo ainda exige esta flag para a carteira e o deploy-prod sobe
  // o customer-api em paralelo; remover depois que o app-integration sem a flag estiver em prod.
  'use_intelligence_wallet',
  ...MOBILITY_SCHEDULING_FEATURE_FLAGS,
  ...GROUP_EVENTS_FEATURE_FLAGS,
  // shortcut: o app-integration antigo ainda exige esta flag para o KM e o deploy-prod sobe o
  // customer-api em paralelo; remover depois que o app-integration sem a flag estiver em prod.
  'use_intelligence_km_refund',
  ...KM_GPS_FEATURE_FLAGS,
  ...MOBILITY_99_BATCH_FEATURE_FLAGS,
  ...VOLL_WALLET_USER_CARD_FEATURE_FLAGS,
  ...COST_CENTER_SPLIT_FEATURE_FLAGS,
  ...INTELLIGENCE_CHAT_FEATURE_FLAGS,
  ...CLASSIC_EXIT_BLOCK_FEATURE_FLAGS,
] as const;

/** `GET /internal/customers/:id/feature-flags` (customer-api → BFF). `null` = não resolvido
 *  (feature-flag-service fora, viajante sem empresa): quem consome esconde (fail-closed). */
export const FeatureFlagsResponseSchema = z
  .object({ featureFlags: z.array(z.string()).nullable() })
  .strict();
export type FeatureFlagsResponse = z.infer<typeof FeatureFlagsResponseSchema>;
